import {MyBackdropStyles} from "./MyBackdrop.styles";
import {MyBackdropProps} from "./MyBackdrop.props";
import React, {JSX} from "react";

export const MyBackdrop = ({setIsShow, isShow}: MyBackdropProps):React.ReactElement => {
  return (
    isShow ? <MyBackdropStyles onClick={setIsShow}/> : <div hidden></div>
  )
}